// src/pages/ContactPage/ContactPage.jsx

import React, { useState } from 'react';
import Navbar from '../../components/Navbar/Navbar'; // Yolu kontrol et
import Footer from '../../components/Footer/Footer'; // Yolu kontrol et
import HeroSection from '../../components/HeroSection/HeroSection'; // Yolu kontrol et
import './ContactPage.css'; // Birazdan oluşturacağız

function ContactPage() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [status, setStatus] = useState(''); // Gönderim durumu mesajı

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('Gönderiliyor...');

    // --- BURASI ÖNEMLİ: Mesajı Nereye Göndereceğiz? ---
    // SEÇENEK A (En Kolay - Formspree/EmailJS):
    // Bu servislerden birini kullanarak backend olmadan email alabilirsin.
    // Örnek (Formspree ile - https://formspree.io/ ):
    /*
    try {
      const response = await fetch('https://formspree.io/f/SENIN_FORM_IDN', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
      if (response.ok) {
        setStatus('Mesajınız başarıyla gönderildi!');
        setFormData({ name: '', email: '', subject: '', message: '' }); // Formu temizle
      } else {
        throw new Error('Form gönderilirken bir hata oluştu.');
      }
    } catch (error) {
      console.error("Form gönderme hatası:", error);
      setStatus('Mesaj gönderilemedi. Lütfen tekrar deneyin.');
    }
    */

    // SEÇENEK B (Firebase Cloud Function / Kendi Backend'in):
    // Veriyi kendi API'na gönderip oradan email atabilir veya Firestore'a kaydedebilirsin.

    // Şimdilik sadece konsola yazdıralım ve başarı mesajı gösterelim:
    console.log('Form Verisi:', formData);
    await new Promise(resolve => setTimeout(resolve, 1000)); // Sahte bekleme
    setStatus('Mesajınız başarıyla gönderildi! (Test Modu)');
    setFormData({ name: '', email: '', subject: '', message: '' }); // Formu temizle
    // -----------------------------------------------------

    // Mesajı birkaç saniye sonra temizle
    setTimeout(() => setStatus(''), 5000); 
  };

  return (
    <div className="contact-page">
      <Navbar />
      <HeroSection
        pageType="small" // Küçük Hero
        title="Bize Ulaşın"
        description="Sorularınız, önerileriniz veya projeleriniz için buradayız."
        showButton={false}
      />

      <div className="container contact-content"> {/* Genel container */}
        <div className="contact-form-container">
          <h2>İletişim Formu</h2>
          <p>Aşağıdaki formu doldurarak bize mesaj gönderebilirsiniz. En kısa sürede size geri dönüş yapacağız.</p>
          
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Adınız Soyadınız</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="email">E-posta Adresiniz</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="subject">Konu</label>
              <input
                type="text"
                id="subject"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="message">Mesajınız</label>
              <textarea
                id="message"
                name="message"
                rows="6"
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>
            </div>

            {/* Gönderim Durumu Mesajı */}
            {status && <p className="form-status">{status}</p>}

            <button type="submit" className="submit-button" disabled={status === 'Gönderiliyor...'}>
              {status === 'Gönderiliyor...' ? 'Gönderiliyor...' : 'Mesajı Gönder'}
            </button>
          </form>
        </div>

       
      </div>

      <Footer />
    </div>
  );
}

export default ContactPage;